import React from 'react'
import { Image } from '../../components/Image'
import cloudImg from './img/cloud.png'

export default function Cloud(props) {
  return <Image src={cloudImg} {...props} />
}
